/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Learn_About_Check_InsInputs */

const en_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn about check-ins`)
};

const de_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr über Check-ins`)
};

const es_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprende sobre check-ins`)
};

const fr_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur les check-ins`)
};

const nl_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer over check-ins`)
};

const it_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di più sulle registrazioni`)
};

const pt_br2_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais sobre check-ins`)
};

const pl_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się o zameldowaniach`)
};

const hu_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudjon meg többet a bejelentkezésekről`)
};

const ro_admin_dashboard_learn_about_check_ins = /** @type {(inputs: Admin_Dashboard_Learn_About_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aflati despre inregistrari`)
};

/**
* | output |
* | --- |
* | "Learn about check-ins" |
*
* @param {Admin_Dashboard_Learn_About_Check_InsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_learn_about_check_ins = /** @type {((inputs?: Admin_Dashboard_Learn_About_Check_InsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Learn_About_Check_InsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "de") return de_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "es") return es_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "fr") return fr_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "nl") return nl_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "it") return it_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "pl") return pl_admin_dashboard_learn_about_check_ins(inputs)
	if (locale === "hu") return hu_admin_dashboard_learn_about_check_ins(inputs)
	return ro_admin_dashboard_learn_about_check_ins(inputs)
});
export { admin_dashboard_learn_about_check_ins as "admin.dashboard.learn_about_check_ins" }